import {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useRef,
    useState,
} from 'react';
import {
    Dialog,
    DialogPanel,
    DialogTitle,
    Transition,
    TransitionChild,
} from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { ChevronLeftIcon } from '@heroicons/react/24/outline/index';

const allOpenPanels = [];
const allOpenPanelIds = [];

const SidePanel = forwardRef(
    (
        {
            isOpen,
            onClose,
            children,
            title,
            widthClass,
            onSave,
            showSave,
            onCancel,
            saveLabel,
            headerLeftContent,
            showBackArrow,
        },
        ref,
    ) => {
        const [id, setId] = useState('' + new Date().getTime() + Math.random());
        const scrollRef = useRef();

        function remove() {
            const idx = allOpenPanelIds.indexOf(id);
            if (idx > -1) {
                allOpenPanels.splice(idx, 1);
                allOpenPanelIds.splice(idx, 1);
            }
        }

        useEffect(() => {
            if (isOpen) {
                // Open, add
                allOpenPanels.push(onClose);
                allOpenPanelIds.push(id);
            } else {
                // Not open, remove
                remove();
            }
        }, [isOpen]);

        useEffect(() => {
            return () => {
                // Unmount, remove
                remove();
            };
        }, []);

        useImperativeHandle(ref, () => {
            return {
                close: onClose,
                closeAllAbove: () => {
                    const idx = allOpenPanelIds.indexOf(id);
                    if (idx > -1) {
                        allOpenPanels.slice(idx + 1).forEach(c => c());
                    }
                    scrollRef.current?.scrollTo(0, 0);
                },
            };
        });

        return (
            <Transition show={isOpen}>
                <div className="relative z-10" onClose={onClose}>
                    {/*<div className="fixed inset-0" />*/}

                    {/*<div className="fixed inset-0 overflow-hidden">*/}
                    {/*<div className="absolute inset-0 overflow-hidden">*/}
                    <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full">
                        <TransitionChild
                            enter="transform transition ease-in-out duration-500"
                            enterFrom="translate-x-full"
                            enterTo="translate-x-0"
                            leave="transform transition ease-in-out duration-500"
                            leaveFrom="translate-x-0"
                            leaveTo="translate-x-full"
                        >
                            <div
                                className={`pointer-events-auto side-panel ${widthClass ? widthClass : 'w-screen max-w-md'}`}
                            >
                                {/*<div className="flex h-full flex-col overflow-y-scroll bg-gray-100 py-6 shadow-xl">*/}
                                <div className="flex h-full flex-col divide-y divide-gray-200 bg-gray-100 shadow-xl">
                                    <div
                                        className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6"
                                        ref={scrollRef}
                                    >
                                        <div className="px-4 sm:px-6">
                                            <div
                                                className={`flex items-start justify-between ${!title ? '-mb-10' : ''}`}
                                            >
                                                {headerLeftContent}
                                                <div className="flex items-center">
                                                    {showBackArrow && (
                                                        <button
                                                            type="button"
                                                            className="text-primary-700"
                                                            onClick={onClose}
                                                        >
                                                            <ChevronLeftIcon
                                                                className="h-5 w-5 mr-2"
                                                                aria-hidden="true"
                                                            />
                                                        </button>
                                                    )}
                                                    <div className="text-base font-semibold leading-6 text-gray-900">
                                                        {title}
                                                    </div>
                                                </div>

                                                <div className="ml-3 flex h-7 items-center">
                                                    <button
                                                        type="button"
                                                        className="relative rounded-md z-10 text-gray-800 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                                        onClick={onClose}
                                                    >
                                                        <span className="absolute -inset-2.5" />
                                                        <span className="sr-only">
                                                            Close panel
                                                        </span>
                                                        <XMarkIcon
                                                            className="h-6 w-6"
                                                            aria-hidden="true"
                                                        />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className={`relative ${title ? 'mt-6' : ''} flex-1 px-4 sm:px-6`}
                                        >
                                            {children}
                                        </div>
                                    </div>
                                    {showSave && (
                                        <div className="bg-primary-700 flex flex-shrink-0 justify-between p-6">
                                            <button
                                                type="submit"
                                                className="p-2 text-primary-700 hover:bg-primary-100 rounded-full bg-white flex-1 mr-4"
                                                onClick={ev => {
                                                    ev.preventDefault();
                                                    onSave();
                                                }}
                                            >
                                                {saveLabel || 'Save'}
                                            </button>
                                            <button
                                                type="button"
                                                className="hover:bg-primary-100 hover:border-primary-100 hover:text-primary-700 bg-primary-700 text-white border-2 border-white rounded-full p-2 flex-1"
                                                onClick={ev => {
                                                    ev.preventDefault();
                                                    onCancel();
                                                }}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </TransitionChild>
                    </div>
                    {/*</div>*/}
                    {/*</div>*/}
                </div>
            </Transition>
        );
    },
);

export default SidePanel;
